import { useEffect, useRef } from "react";

import { consoleLogError } from "../../utils/console";
import { DATA_ATTR_PARA_ID, READER_VIEW_CLASS_NAME_PARA_WRAP } from "../../utils/reader/constants";
import { CONTENT_CLASSES } from "../../utils/content/content.constants";
import { inRect } from "../../utils/dom";

const useReaderPanelLink = (
  view, link, classNameActive, enabled = true, onScrollLinkIntoView,
) => {
  const refIsMountScrollToLinkPassed = useRef(false);

  useEffect(() => {
    let elLink;

    if (view && link && enabled) {
      const {
        paraIdFrom,
        idOriginal,
        indexInPara
      } = link;

      if (idOriginal && paraIdFrom) {
        const paraSuitable = view.querySelector(
          `.${READER_VIEW_CLASS_NAME_PARA_WRAP}[${DATA_ATTR_PARA_ID}="${paraIdFrom}"]`
        );
        if (!paraSuitable) {
          return;
        }

        if (indexInPara !== undefined && indexInPara !== -1) {
          elLink = paraSuitable.querySelectorAll("." + CONTENT_CLASSES.EGW_LINK)?.[indexInPara];
        }
        if (!elLink) {
          elLink = paraSuitable.querySelector(
            `.${CONTENT_CLASSES.EGW_LINK}[data-link="${idOriginal}"]`
          );
        }

        if (elLink) {
          elLink.classList.add(classNameActive);

          const computedStyle = window.getComputedStyle(elLink);

          let heightTextLine;

          if (computedStyle) {
            const floatFontSize = parseFloat(computedStyle.fontSize);
            const floatLineHeight = parseFloat(computedStyle.lineHeight);

            heightTextLine = floatFontSize * (floatLineHeight / floatFontSize);
          }

          const paddingVisibilityVertical = heightTextLine / 2;

          const isLinkInViewRect = inRect(view.getBoundingClientRect(), elLink.getBoundingClientRect(), {
            fully: !refIsMountScrollToLinkPassed.current,
            paddingVertical: paddingVisibilityVertical,
          });

          if (!isLinkInViewRect) {
            elLink.scrollIntoView({
              block: "center",
            });

            if (onScrollLinkIntoView) {
              onScrollLinkIntoView();
            }
          }
        }
      } else {
        consoleLogError("Reader panel", "Active link object is invalid", link);
      }
    }

    if (view) {
      refIsMountScrollToLinkPassed.current = true;
    }

    return () => {
      if (elLink) {
        elLink.classList.remove(classNameActive);
      }
    };
  }, [view, link, classNameActive, enabled, onScrollLinkIntoView]);
};

export default useReaderPanelLink;
